<template>
		<div class="home-page">
    <div class="header-bgfff bgfff">
      <Header></Header>
      <div class="nav ac">
        <div class="back" @click="back" >
          <img width="40" src="../../static/images/back2.png" />
        </div>
        {{book_detail.name}}
      </div>
    </div>
			<div class="home-content crfff">
        <div class="pdf-viewer" v-if="book_detail.path">
          <iframe :src="book_detail.path" frameborder="0" width="100%" height="100%"></iframe>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
        book_detail:{},
        id:0,
      }
    },
	created(){
    if(this.$route.query.id){
      this.id = this.$route.query.id
      this.get_detail();
    }
	},
  methods: {
		back(){
      this.$router.go(-1);
		},

    get_detail() {
      let that =this;
      that.$parent.loadModal(true);
      that.$api.post('/api/book/detail', {"id":that.id},r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          that.book_detail = r.data;
        });
      })
    },

	}
}
</script>
<style>
.pdf-viewer {
  width: 100%;
  height: calc(100vh - 100px); /* 留出顶部导航高度 */
}

</style>



// WEBPACK FOOTER //
// src/page/BookDetail2.vue